<template>
  <div>
    <Title :title="'运营业务收入'" :isActiveSec="true"></Title>
    <Chart :cdata="cdata" :width="style.width" :height="style.height"/>
  </div>
</template>

<script>
import Chart from '../chart.vue'
import Title from '../../title.vue'
import { dataInterface } from '@/api/dataInterfaceApi';


export default {
  data () {
    return {
      cdata: {
        category: [],
        rateData: [],
        id:"operateIncomeChart",
        legendData:[{
              name:"本月",
              icon: 'roundRect',
            }, {
              name:"上个月",
              icon: 'roundRect',
        }],
        series:[
            {
              name: "本月",
              type: "bar",
              stack: 'one',
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#027BF7" },
                    { offset: 1, color: "#3D9FFF" }
                  ])
                }
              },
              data: []
            },
            {
              name: "上个月",
              type: "bar",
              stack: 'one',
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#65E2B6" },
                    { offset: 1, color: "#B8FF7E" }
                  ])
                }
              },
              data: []
            },
        ]
      },
      style:{
        width: '500',
        height: '200'
      }
    };
  },
  components: {
    Chart,
    Title
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectStationRcvAmount(data);
    },
    selectStationRcvAmount(data={}){
      let _this = this;
      let params = {};
				
      params = {
        "enCode":"TiDB-zhandian-yunyingyewushouru",
    		"@station_id":data.stationId
      }
		
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          let date = new Date();
          let cur_income = [];
          let last_income = [];
          let xList = [];
          res.forEach(item=>{
            cur_income.push(item.cur_oper_income);
            last_income.push(item.last_oper_income);
            xList.push(item.cur_date);
          })
          this.cdata.series[0].data = cur_income;//本月
          this.cdata.series[1].data = last_income;//上月
          this.cdata.category = xList;
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
};
</script>

<style lang="scss" scoped>
</style>